import { GetState, SetState } from 'zustand';
import { SettingsStore } from 'store';

export function switchToolsDrawer(set: SetState<SettingsStore>, get: GetState<SettingsStore>): void {
   set({ toolsDrawerOpened: !get().toolsDrawerOpened });
}
